var exports = {
  "r": "body__eDhkfJ",
  "q": "footer__cDuNdP",
};

module.exports = exports;
